import script from "./SignUpForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpForm.vue?vue&type=script&setup=true&lang=js"

import "./SignUpForm.vue?vue&type=style&index=0&id=732dadc8&lang=scss"

const __exports__ = script;

export default __exports__